import type { UserRole } from '../types/gateway';
import { getRoleConfig } from '../config/roles';
import styles from './QuickActions.module.css';

interface QuickActionsProps {
  role: UserRole;
  onSelect: (prompt: string) => void;
}

export function QuickActions({ role, onSelect }: QuickActionsProps) {
  const cfg = getRoleConfig(role);
  if (cfg.quickActions.length === 0) return null;

  return (
    <section
      className={styles.section}
      data-accent={cfg.accent}
      aria-label={`Quick actions for ${cfg.label}`}
    >
      <div className={styles.heading}>
        <span className={styles.headingLabel}>Quick actions for</span>
        <span className={styles.headingRole}>{cfg.label}</span>
      </div>
      <div className={styles.grid}>
        {cfg.quickActions.map((action) => (
          <button
            key={action.title}
            type="button"
            className={styles.card}
            onClick={() => onSelect(action.prompt)}
          >
            <span className={styles.cardIcon}>{action.icon}</span>
            <span className={styles.cardBody}>
              <span className={styles.cardTitle}>{action.title}</span>
              <span className={styles.cardDesc}>{action.description}</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
